import { Button, Flex, Input } from '@bynder/design-system';
import { IconEdit, IconPublic, IconUnlink } from '@bynder/icons';

type PreviewLinkProps = {
  href: string | null;
  onEdit: () => void;
  onUnlink: () => void;
};

export const PreviewLink = ({ href, onEdit, onUnlink }: PreviewLinkProps) => (
  <>
    <Flex gap={'2'}>
      <Input
        aria-label="hyperlink url"
        icon={<IconPublic />}
        value={href ?? ''}
        isDisabled
      />
      <Button
        variant="clean"
        aria-label="edit link"
        onClick={onEdit}
        icon={<IconEdit />}
      />
      <Button
        variant="clean"
        aria-label="unlink link"
        onClick={onUnlink}
        icon={<IconUnlink />}
      />
    </Flex>
  </>
);
